import React, { forwardRef } from "react"
import { SidePane } from "../../../../Common/fSidePane/RightPane"
import { CostAllocation } from "../../../fCommon/Submit/MultiSubmitInvoice/CostAllocation"
import Spinner from "react-spinner-material";
import { useSelector } from "react-redux";

export const PoCostAllocation = forwardRef(({updateCostAllocation,allocation, onClose, data, onAdd ,loading}, ref) => {
    const {costAllocationOnBaseAmount} = useSelector(state=>state.auth.config.plugins);
    let baseAmount = 0;

    data.procured.forEach(item => {
        if(item.base){
            baseAmount += item.base;
        }
    });
    
    return (
        <SidePane button={false} column={false} onClose={onClose}>
            <CostAllocation
                ref={ref}
                totalAmount={costAllocationOnBaseAmount?baseAmount:data.currencyAmount}
                // totalAmount={data.currencyAmount}
                prefillAllocations={allocation && allocation.data && allocation.data.allocations}
                category={data.category.id}
            />
            {loading ?
                <div className='btn btn-portlet-success' style={{ height:55, background: "#E4EFE7", 'min-width': '100%',display:'flex',alignItems:'center',justifyContent:'center' }}>
                    <Spinner  radius={20} stroke={2}/>
                </div>
                :
                <div onClick={onAdd} className='btn btn-portlet-success' style={{ background: "#E4EFE7", 'min-width': '100%' }}>
                    {updateCostAllocation ? "Update Cost Allocation" : "Add Cost Allocation"}
                </div>
            }
        </SidePane>
    )
})